// packages/web/src/hooks/useIsMobile.ts
import { useEffect, useState } from 'react';
import { MOBILE_MEDIA_QUERY } from '@/lib/breakpoints';

/**
 * Reactive boolean: true when the viewport is in the mobile (phone) range.
 * SSR-safe: returns false when `window` is unavailable.
 */
export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (e: MediaQueryListEvent): void => {
      setIsMobile(e.matches);
    };
    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return (): void => {
      mql.removeEventListener('change', onChange);
    };
  }, []);

  return isMobile;
}
